export enum EvaluationErrorEnum {
    NONE = "NONE",
    INFERENCE_INTERNAL_ERROR = "INFERENCE_INTERNAL_ERROR",
    VIDEO_QUALITY_ERROR = "VIDEO_QUALITY_ERROR",
    UPLOAD_TIMEOUT = "UPLOAD_TIMEOUT", // this field does not exist in backend system, used this as an indicator for upload timeout
}
